angular.module('unica_invitation_group.invitation_group_services', []);